import React, { useRef, useState, useEffect } from 'react'
import _ from 'lodash'
import Image from 'next/image'
import { useTheme } from 'contexts/ThemeProvider'
import themeStyles from './styles'
import { localization } from 'components/Tiles/WellnessResources/localization'
import withLocalization from '@web/helpers/localizationUtils'

function MobileSlider(props) {
  const { items = [], t } = props
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const [startX, setStartX] = useState(null)
  const [dragX, setDragX] = useState(0)

  const scrollRef = useRef(null)

  const handleScroll = scrollX => {
    if (scrollRef.current && scrollX) {
      const offset = scrollRef.current.clientWidth * 0.5
      if (scrollX > 0) {
        scrollRef.current.scrollLeft = scrollRef.current.scrollLeft - offset
      }
      if (scrollX < 0) {
        scrollRef.current.scrollLeft = scrollRef.current.scrollLeft + offset
      }
    }
  }

  const handleMouseDown = event => {
    setStartX(event.clientX)
  }

  const handleMouseMove = _.throttle(event => {
    if (startX) {
      const deltaX = event.clientX - startX
      setDragX(deltaX)
    }
  }, 100)

  const handleMouseUp = () => {
    setStartX(null)
    setDragX(0)
  }

  useEffect(() => {
    if (dragX && dragX !== 0) {
      handleScroll(dragX)
    }
  }, [dragX])

  return (
    <div
      style={styles.mobileSlider}
      className='mobileSlider'
      ref={scrollRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      {items.map((item, index) => {
        return (
          <div key={index} style={styles.slide}>
            <div style={styles.slideImage}>
              <Image
                src={item.image}
                alt={item.title}
                unoptimized
                fill
                style={{
                  objectFit: 'cover'
                }}
              />
            </div>
            <div style={styles.slideInfo}>
              <div style={styles.slideText}>
                <span style={styles.slideTitle}>{item.title}</span>
                <span style={styles.slideDescription}>{item.description}</span>
              </div>
              <a
                href={item.link}
                target='_blank'
                rel='noreferrer'
                style={styles.slideLink}
              >
                {t('read')}
              </a>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default withLocalization(MobileSlider, localization)
